import axios from 'axios'

export default {
  index() {
    return axios.get('/integraciones/integraciones/')
  },
  getSucursales(uuid) {
    return axios.get(`/integraciones/integraciones/${uuid}/sucursales/`)
  },
  updateSucursal(uuid, data) {
    return axios.post(`/integraciones/integraciones/${uuid}/sucursales/`, data)
  },
  getCategorias(uuid, sucursal_uuid) {
    return axios.get(`/integraciones/integraciones/${uuid}/categorias/`, { params: { sucursal_uuid } })
  },
  updateCategoria(uuid, data) {
    return axios.post(`/integraciones/integraciones/${uuid}/categorias/`, data)
  },
  // params: sucursal_uuid (obligatorio), q, solo_ocultos, page
  getProductos(uuid, params) {
    return axios.get(`/integraciones/integraciones/${uuid}/productos/`, { params })
  },
  updateProducto(uuid, data) {
    return axios.post(`/integraciones/integraciones/${uuid}/productos/`, data)
  },
  getTiendaOnline() {
    return axios.get('/integraciones/integraciones/tienda-online/')
  },
  activarTiendaOnline() {
    return axios.post('/integraciones/integraciones/tienda-online/')
  },
  // `data` es un objeto (JSON) o un FormData (para subir logo o banner)
  updateVitrina(uuid, data) {
    return axios.patch(`/integraciones/integraciones/${uuid}/vitrina/`, data)
  },
  verificarDominio(uuid) {
    return axios.post(`/integraciones/integraciones/${uuid}/vitrina/verificar-dominio/`)
  }
}
